module.exports = __webpack_public_path__ + "0caa1cc5fef3536c7b90cedd6355949f.pdf";